export default __webpack_public_path__ + "static/media/hht1_eggstudio.cd4a2b86.png";